interface DomainOption {
    label: string;
    value: string | number;
}

interface BuildOfferLinkUrlParams {
    currentUrl?: string;
    customDomainOptions: DomainOption[];
    defaultDomainValue: string;
    domain: string;
    offerLinkSlug?: string;
    tenantSlug?: string;
    trackingUrl?: string;
}

export const buildOfferLinkUrl = ({
    currentUrl,
    customDomainOptions,
    defaultDomainValue,
    domain,
    offerLinkSlug,
    tenantSlug,
    trackingUrl,
}: BuildOfferLinkUrlParams): string => {
    if (!offerLinkSlug || !tenantSlug) {
        return "";
    }

    let domainBase = "";

    if (domain === defaultDomainValue) {
        if (trackingUrl) {
            domainBase = `${trackingUrl}/link/${tenantSlug}`;
        }
    } else {
        const customDomainOption = customDomainOptions.find((option) => String(option.value) === domain);

        if (customDomainOption) {
            domainBase = `https://${customDomainOption.label}/link/${tenantSlug}`;
        }
    }

    if (!domainBase) {
        return "";
    }

    let url: URL;
    try {
        url = new URL(`${domainBase}/${offerLinkSlug}`);
    } catch {
        return "";
    }

    if (currentUrl) {
        try {
            url.search = new URL(currentUrl).search;
        } catch {
            // Ignore invalid current URLs when preserving query parameters.
        }
    }

    return url.toString();
};
